import { listarLayoutsImpressao } from "../../../services/configuracoes-impressora"
import { TextoModel } from "../models/textoModel"
import {
    mesclarCamposComPadrao,
    ParametrosGeraisInicial,
    TextoImpressaoInicial,
} from "./textoImpressaoInicial"

const STORAGE_KEY = "configuracoesDeTexto"
const STORAGE_KEY_LAYOUTS = "layoutsDeTextoImpressao"
const STORAGE_KEY_LAYOUT_ATIVO = "layoutImpressaoSelecionadoId"

function layoutBackendParaModelo(layout: any): TextoModel {
    const pg = layout.parametrosGerais

    return {
        id: layout.id !== undefined ? String(layout.id) : undefined,
        nome: layout.nome ?? TextoImpressaoInicial.nome,
        parametrosGerais: {
            ...ParametrosGeraisInicial,
            ...pg,
            exibirLogo: Boolean(pg?.exibirLogo),
            linhaAposProduto: Boolean(pg?.linhaAposProduto),
        },
        ...mesclarCamposComPadrao(layout.campos),
    }
}

export function getConfiguracoesDeTextoLocal(): TextoModel {
    if (typeof window === "undefined") {
        return TextoImpressaoInicial
    }

    const data = window.localStorage.getItem(STORAGE_KEY)

    if (!data) return TextoImpressaoInicial

    try {
        const parsed = JSON.parse(data)
        return {
            ...TextoImpressaoInicial,
            ...parsed,
            parametrosGerais: {
                ...TextoImpressaoInicial.parametrosGerais,
                ...(parsed.parametrosGerais ?? {}),
            },
        } as TextoModel
    } catch {
        return TextoImpressaoInicial
    }
}

export function setConfiguracoesDeTextoLocal(config: TextoModel) {
    if (typeof window === "undefined") return
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
}

export function getLayoutsImpressaoLocal(): Record<string, TextoModel> {
    if (typeof window === "undefined") return {}

    try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY_LAYOUTS) || "{}")
    } catch {
        return {}
    }
}

export function setLayoutsImpressaoLocal(layouts: TextoModel[]) {
    if (typeof window === "undefined") return

    const mapa: Record<string, TextoModel> = {}
    layouts.forEach(layout => {
        if (layout.id !== undefined) mapa[layout.id] = layout
    })
    window.localStorage.setItem(STORAGE_KEY_LAYOUTS, JSON.stringify(mapa))
}

export function getLayoutImpressaoLocalPorId(id: string): TextoModel | undefined {
    return getLayoutsImpressaoLocal()[id]
}

export function getLayoutAtivoIdLocal(): string | undefined {
    if (typeof window === "undefined") return undefined
    return window.localStorage.getItem(STORAGE_KEY_LAYOUT_ATIVO) ?? undefined
}

export function setLayoutAtivoIdLocal(id: string | undefined) {
    if (typeof window === "undefined") return
    if (id === undefined) window.localStorage.removeItem(STORAGE_KEY_LAYOUT_ATIVO)
    else window.localStorage.setItem(STORAGE_KEY_LAYOUT_ATIVO, id)
}

export async function sincronizarConfiguracoesDeTexto(autorizacao: string): Promise<void> {
    try {
        const response = await listarLayoutsImpressao(autorizacao)
        if (response?.retornoErro || !Array.isArray(response) || !response.length) return

        const layouts = response.map(layoutBackendParaModelo)
        setLayoutsImpressaoLocal(layouts)

        const idSalvo = getLayoutAtivoIdLocal()
        const layoutAtivo = layouts.find(l => l.id === idSalvo) ?? layouts[0]
        setConfiguracoesDeTextoLocal(layoutAtivo)
        setLayoutAtivoIdLocal(layoutAtivo.id)
    } catch {}
}
